import request from "@/app/api/request";
import {
  OpenMatchAddUserModel,
  OpenMatchModel,
  OpenMatchModelResponse, OpenMatchRemoveUserModel,
  OpenMatchRequestModel, OpenMatchUpdateCourtModel,
  OpenMatchUpdateStatusModel
} from "@/app/api/open_match/models";

export class OpenMatchRequests {
  static async createMatch(model: OpenMatchModel): Promise<OpenMatchModel> {
    try {
      return await request.post<OpenMatchModel>('/open-match/create', {data: model});
    } catch (error: any) {
      throw error;
    }
  }

  static async getMatches(model: OpenMatchRequestModel): Promise<OpenMatchModelResponse[]> {
    try {
      const queryModel: Record<string, any> = {...model};

      if (model.eventDate) {
        const date = new Date(model.eventDate);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        queryModel.eventDate = `${year}-${month}-${day}`;
      }

      return await request.get<OpenMatchModelResponse[]>('/open-match/search', {query: queryModel});
    } catch (error: any) {
      throw error;
    }
  }

  static async updateStatus(model: OpenMatchUpdateStatusModel): Promise<OpenMatchModelResponse> {
    try {
      return await request.patch<OpenMatchModelResponse>('/open-match/updateStatus', {query: model});
    } catch (error: any) {
      throw error;
    }
  }

  static async updateMatch(model: OpenMatchUpdateCourtModel, id: number): Promise<OpenMatchModelResponse> {
    try {
      return await request.patch<OpenMatchModelResponse>('/open-match/update', {query: {matchId: id}, data: model});
    } catch (error: any) {
      throw error;
    }
  }

  static async addUser(model: OpenMatchAddUserModel): Promise<OpenMatchModelResponse> {
    console.log(model)
    try {
      return await request.post<OpenMatchModelResponse>('/open-match/addUser', {query: model});
    } catch (error: any) {
      throw error;
    }
  }

  static async removeUser(model: OpenMatchRemoveUserModel): Promise<OpenMatchModelResponse> {
    try {
      return await request.delete<OpenMatchModelResponse>('/open-match/deleteUser', {query: model});
    } catch (error: any) {
      throw error;
    }
  }
}

